/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeartbeatRequest
 */
export interface HeartbeatRequest {
    /**
     * 
     * @type {string}
     * @memberof HeartbeatRequest
     */
    role: string | null;
}

/**
 * Check if a given object implements the HeartbeatRequest interface.
 */
export function instanceOfHeartbeatRequest(value: object): value is HeartbeatRequest {
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function HeartbeatRequestFromJSON(json: any): HeartbeatRequest {
    return HeartbeatRequestFromJSONTyped(json, false);
}

export function HeartbeatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeartbeatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'],
    };
}

export function HeartbeatRequestToJSON(json: any): HeartbeatRequest {
    return HeartbeatRequestToJSONTyped(json, false);
}

export function HeartbeatRequestToJSONTyped(value?: HeartbeatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'role': value['role'],
    };
}

